<template>
  <v-app v-cloak>
    <!-- Header -->
    <Header
      v-bind:prop_user="authenticatedUser">
    </Header>

	 <v-app-bar
		app
		flat
		height="72">
		<v-card-title class="content-title">Download Campagne Territoriali</v-card-title>
	</v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawerLeftVisible"
      :width="overrideDrawerWidth">
      <DtmLeftPanel
			v-if="mapConfig != null"
			v-bind:prop_campagna_cod="campagnaCod"> 
		</DtmLeftPanel>
    </v-navigation-drawer>

    <!-- Page content -->
    <v-main>
      <DtmContent
			v-if="mapConfig != null"
			v-bind:prop_map_config="mapConfig"> 
		</DtmContent>

      <!-- Loading -->
      <Loader></Loader>
      <!-- Dialog Success -->
      <DialogSuccess></DialogSuccess>
      <!-- Dialog Error -->
      <DialogError></DialogError>
      <!-- Dialog Confirm -->
      <DialogConfirm></DialogConfirm>
    </v-main>
  </v-app>
</template>

<style>
	.content-title {
		font-size: 18px;
		color: #006a9b;
	}
</style>

<script>
import "@/assets/css/app.css";
import "@/assets/css/utils.css";

import { LAYOUT } from "@/configs/layoutConfigs.js";
import Header from "@/components/header/Header.vue";

const { RequestsUtils } = require("@/assets/js/scripts/utils/RequestsUtils");
const { PiwikSIGMA } = require("@/assets/js/scripts/piwik/PiwikSIGMA");

import Loader from "@/components/widgets_utils/Loader";
import DialogSuccess from "@/components/widgets_utils/dialog/DialogSuccess";
import DialogError from "@/components/widgets_utils/dialog/DialogError";
import DialogConfirm from "@/components/widgets_utils/dialog/DialogConfirm";

import DtmContent from "./components/DtmContent";
import DtmLeftPanel from "./components/DtmLeftPanel";

import VueMatomo from 'vue-matomo';

export default {
	name: "AppDtm",
	props: [],

	components: {
		Loader,
		DialogSuccess,
		DialogError,
		DialogConfirm,

		Header,
		DtmLeftPanel,
		DtmContent
	},

	created() {
		this.getUserLogged();
		this.getCampagnaCodFromQueryString();
		this.getMapConfig();

		PiwikSIGMA.trackPage();
	},

	data() {
		return {
			LAYOUT,
			overrideDrawerWidth: 400,
			drawerLeftVisible: null,
			authenticatedUser: {},

			campagnaCod: null,
			mapConfig: null,
		};
	},

	methods: {
		getUserLogged() {
			RequestsUtils.get("../authentication/getLoggedInUserInfo",
				// Params
				{},
				// Success Callback
				function (response) {
					this.authenticatedUser = response.data.result;
				}.bind(this),
				// Fail Callback
				null,
				// Show Message success
				false,
				// Show Loading
				true
			);
		},

		getCampagnaCodFromQueryString() {
			const params = new URLSearchParams(window.location.search);

			if(params.has('cod')) {
				this.campagnaCod = params.get('cod');
			}
		},

		getMapConfig() {
			RequestsUtils.get("../dtm/getDtmMinimappaConfig",
				// Params
				{},
				// Success Callback
				function (response) {
					this.mapConfig = response.data.result;
				}.bind(this),
				// Fail Callback
				null,
				// Show Message success
				false,
				// Show Loading
				true
			);
		}
		
	},
};
</script>